import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const BaseballGray = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox={'0 0 24 24'} xmlns="http://www.w3.org/2000/svg">
            <g id="Baseball_Gray" fill="none">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7782 4.22183C24.0739 8.51761 24.0739 15.4824 19.7782 19.7782C15.4824 24.0739 8.51761 24.0739 4.22183 19.7782C-0.0739441 15.4824 -0.0739441 8.51761 4.22183 4.22183C8.51761 -0.0739441 15.4824 -0.0739441 19.7782 4.22183ZM5.63605 5.63605C2.12132 9.15077 2.12132 14.8492 5.63605 18.364L5.84528 18.5666C9.3734 21.8773 14.9181 21.8098 18.364 18.364C21.8787 14.8492 21.8787 9.15077 18.364 5.63605C14.8492 2.12132 9.15077 2.12132 5.63605 5.63605Z"
                    fill="#0A0B0D"
                />
                <path
                    d="M22.6445 12.6801C19.4669 15.3587 14.7441 15.1695 11.7873 12.2127C8.83051 9.25596 8.64134 4.53307 11.32 1.35549L12.8491 2.64454C10.8386 5.02954 10.9808 8.57777 13.2015 10.7985C15.4222 13.0193 18.9705 13.1614 21.3555 11.1509L22.6445 12.6801Z"
                    fill="#54586A"
                />
                <path
                    d="M9.56518 21.5044C9.19156 19.7857 8.33775 18.2064 7.0657 16.9343C5.79364 15.6623 4.21434 14.8085 2.49565 14.4349L2.9205 12.4805C5.0112 12.935 6.93463 13.9748 8.47991 15.5201C10.0252 17.0654 11.065 18.9888 11.5195 21.0795L9.56518 21.5044Z"
                    fill="#54586A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.7782 4.22183C24.0739 8.51761 24.0739 15.4824 19.7782 19.7782C15.4824 24.0739 8.51761 24.0739 4.22183 19.7782C-0.0739441 15.4824 -0.0739441 8.51761 4.22183 4.22183C8.51761 -0.0739441 15.4824 -0.0739441 19.7782 4.22183ZM5.63605 5.63605C2.12132 9.15077 2.12132 14.8492 5.63605 18.364L5.84528 18.5666C9.3734 21.8773 14.9181 21.8098 18.364 18.364C21.8787 14.8492 21.8787 9.15077 18.364 5.63605C14.8492 2.12132 9.15077 2.12132 5.63605 5.63605Z"
                    fill="#0A0B0D"
                />
            </g>
        </svg>
    );
};
